import React from 'react';
import { Link } from 'react-router-dom';
function Footer() {
  return (
    <footer className="bg-[#071E56] text-white pt-20 pb-10 mt-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <h2 className="text-3xl font-bold mb-5">
              Praneesh Infotech
            </h2>

            <p className="text-gray-300 leading-8 text-lg">
              Modern website development, mobile applications,
              ecommerce platforms and custom software solutions.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold mb-6">Quick Links</h3>

            <ul className="space-y-4 text-gray-300 text-lg">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/projects">Projects</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-bold mb-6">Services</h3>

            <ul className="space-y-4 text-gray-300 text-lg">
              <li>Website Development</li>
              <li>Mobile App Development</li>
              <li>Billing Software</li>
              <li>eCommerce Solutions</li>
              <li>Digital Marketing</li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-bold mb-6">Contact Info</h3>

            <div className="space-y-5 text-gray-300 text-lg leading-8">
              <p>📞 +91 94879 24282</p>
              <p>🌐 www.praneeshinfotech.com</p>
              <p>
                📍 27-B/5, Ayyampalayam Pudur,
                Ayyampalayam (Post), Kavindapadi - Erode - 638455
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-gray-400 text-lg">
          © 2026 Praneesh Infotech. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
